import { render } from "./AwardIcon.vue?vue&type=template&id=e39a0ec2"
import script from "./AwardIcon.vue?vue&type=script&lang=js"
export * from "./AwardIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__